/**
 * ERP success envelope often uses message "radha" — show a human action label instead.
 * If server sends a real message, prefer that.
 */
export function hrmsSuccessMessage(res, actionLabel) {
  const raw = res?.message;
  const m = typeof raw === "string" ? raw.trim() : "";
  if (
    m &&
    m.toLowerCase() !== "radha" &&
    m.length > 0 &&
    !/^ok$/i.test(m)
  ) {
    return m;
  }
  return actionLabel;
}
